// Public, unauthenticated endpoints of the services layer (settings, legal
// pages, quote requests, consulting tickets). Shares the axios instance.
import { api } from "@/lib/api";

export async function getSiteSettings() {
  const { data } = await api.get("/site-settings");
  return data;
}

export async function getLegalPage(slug) {
  const { data } = await api.get(`/pages/${encodeURIComponent(slug)}`);
  return data;
}

export async function getTestimonials() {
  const { data } = await api.get("/testimonials");
  return data.testimonials;
}

export async function submitQuoteRequest(payload) {
  const { data } = await api.post("/quote-requests", payload);
  return data;
}

export async function listTickets(token) {
  const { data } = await api.get(`/report/${encodeURIComponent(token)}/tickets`);
  return data;
}

export async function createTicket(token, payload) {
  const { data } = await api.post(`/report/${encodeURIComponent(token)}/tickets`, payload);
  return data;
}

export async function replyTicket(token, ticketId, message) {
  const { data } = await api.post(
    `/report/${encodeURIComponent(token)}/tickets/${encodeURIComponent(ticketId)}/messages`,
    { message }
  );
  return data;
}
